// @ts-check
import { gql } from '@apollo/client/core';
import React from 'react';
import { Flex, QRCode, Text } from '../../pdf-design-system';
import Avery8164ShippingLabels, {
  LabelItem,
} from '../AveryTemplates/Avery8164ShippingLabels';

/**
 *
 * @param {object} props
 * @param {string} props.locale
 * @param {object} props.data
 * @param {object} props.data.collection
 * @param {object} props.data.collection.site
 * @param {string} props.data.collection.site.publicUrl
 * @param {object[]} props.data.sections
 * @param {boolean} [props.border=false] Show the outline for the label. Useful for debugging
 * @returns
 */
export default function ExhibitorQrCodeLabels8164({
  data,
  locale,
  border,
  ...rest
}) {
  const { collection } = data;
  const sections = afterQuery(data, rest);

  return (
    <Avery8164ShippingLabels>
      {sections.map((section) => {
        return (
          <LabelItem border={border}>
            <Flex
              style={{
                width: '100%',
                padding: '2mm',
                paddingTop: '5mm',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <QRCode
                margin={0}
                url={`${collection.site.publicUrl}/e/${section.registration.companyId}`}
                style={{
                  height: '4cm',
                  width: '4cm',
                  marginHorizontal: '4mm',
                  marginBottom: '3mm',
                }}
              />
              <Text>{section.registration.name}</Text>
            </Flex>
          </LabelItem>
        );
      })}
    </Avery8164ShippingLabels>
  );
}

ExhibitorQrCodeLabels8164.fragment = gql`
  fragment ExhibitorQrCodeLabels8164 on CatalogConfiguration {
    catalogConfigurationId
    collectionId
    collection {
      collectionId
      eventId: collectionId
      site {
        publicUrl
      }
    }
    sections {
      __typename
      ... on RegistrationCatalogSection {
        registration {
          registrationId
          companyId
          name
        }
      }
    }
  }
`;

function afterQuery(data, rest) {
  if (rest.companyId) {
    return data.sections?.filter(
      (section) =>
        section.__typename === 'RegistrationCatalogSection' &&
        section.registration.companyId === rest.companyId
    );
  }
  if (rest.registrationId) {
    return data.sections?.filter(
      (section) =>
        section.__typename === 'RegistrationCatalogSection' &&
        section.registration.registrationId === rest.registrationId
    );
  }

  return data.sections;
}
